export enum Co2DatasetType {
  SOURCE = 0,
  SINK = 1,
  BOTH = 2,
}
